<template>
  <div>
    <c-crud-filters :is-mobile="isMobile">
      <template v-slot:content>
        <v-row>
          <v-col cols="12" md="1" xs="2" id="date-filter-select" align-self="center" align="end">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon>mdi-calendar-multiple</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in calendarPeriods"
                  :key="index"
                  @click="changePeriod(item.value)"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2" xs="8" id="date-filter">
            <v-date
              v-model="filters.date"
              @change="goToDate()"
              :label="$lang('main.words.date')"
              scrollable
              :prepend-icon="''"
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="8" xs="12" align-self="center" align="end">
            <v-menu v-if="$can('CUSTOMIZE_CALENDAR')" offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  :small="isMobile"
                  :block="isMobile"
                >
                  <v-icon color="green darken-2" class="mr-1">mdi-eye-settings</v-icon>
                  {{ $lang('calendar.settings.stored') }}
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="">
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="settingsTitle"
                      :label="$lang('calendar.settings.store')"
                      dense
                      hide-details
                    />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="storeSettings()">
                      <v-icon>mdi-content-save-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              <!-- </v-list> -->

              <v-divider></v-divider>

              <!-- <v-list> -->
                <v-subheader>{{ $lang('calendar.settings.stored') }}</v-subheader>

                <v-list-item-group active-class="">
                  <v-list-item v-for="(item, i) in storedSettings" :key="`setting-${i}`" @click="chooseSettings(item.title)">
                    <template v-slot:default="{ active }">
                      <v-list-item-title>
                        <v-icon v-if="item.isActive" class="mr-1">mdi-check</v-icon>
                        {{ item.title }}
                      </v-list-item-title>
                      <v-list-item-action>
                        <v-btn icon @click.stop="removeSettings(item.title)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <SettingsMenu v-if="$can('CUSTOMIZE_CALENDAR')" :small="isMobile" />
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="primary"
                  :small="isMobile"
                  :block="isMobile"
                >
                  {{ $lang('main.crud.actions') }}
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-group :value="true">
                  <template v-slot:activator>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-chart-gantt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $lang("main.titles.reservations_calendar")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item :disabled="$cannot('CREATE_RESERVATIONS')" @click="openCreationWizard()">
                    <v-list-item-title><v-icon>mdi-plus</v-icon> {{ $lang("main.crud.add") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :disabled="$cannot('CREATE_RESERVATIONS')" @click="openCreationMultiple">
                    <v-list-item-title><v-icon>mdi-plus-box-multiple-outline</v-icon> {{ $lang("main.crud.add_multiple") }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <v-list-group :value="true">
                  <template v-slot:activator>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-finance</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $lang("main.titles.rate_calendar")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item @click="openBulkCreation()">
                    <v-list-item-title><v-icon class="mr-1" color="warning">mdi-pencil-box-multiple-outline</v-icon>{{ $lang('main.words.edit_bulk') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :to="{ name: 'rate-history' }" :disabled="$cannot('VIEW_RATE_HISTORY')">
                    <v-list-item-title><v-icon class="mr-1">mdi-history</v-icon>{{ $lang('main.titles.rate_history') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openCopy()">
                    <v-list-item-title><v-icon class="mr-1">mdi-content-copy</v-icon>{{ $lang('rate-calendar.title_copy') }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </template>
    </c-crud-filters>
    <Legend />
    <v-container fluid class="mt-2" id="calendar-container">
      <div id="wrapper" class="calendar scroll">
        <div v-if="filters.show_ruler" id="ruler">
          <div id="track-container">
            <div id="track"></div>
            <div id="track-element"></div>
          </div>
        </div>
        <div id="header">
          <div id="months-row" class="calendar__row calendar__row--months grid-template-count" style="z-index: 4;">
            <div class="calendar__row-first blue-grey"></div>
            <span v-for="(month, monthNumber) in months" :key="monthNumber" class="blue-grey" :style="`gridColumn: span ${month.length}; border-left: 1px solid rgba(0,0,0,0.1) !important; overflow: hidden;`">
              {{ $moment().month(monthNumber.slice(2)).locale($locale()).format('MMMM')  }}<br/>
            </span>
          </div>
          <div id="dates-row" class="calendar__row calendar__row--months grid-template-count" ref="dates_row">
            <div class="calendar__row-first blue-grey">
              <div class="d-flex justify-space-between">
                <div>
                  <v-btn icon @click="prev()" :disabled="loading" small>
                    <v-icon color="white">mdi-chevron-double-left</v-icon>
                  </v-btn>
                  <v-btn icon @click="prev(true)" :disabled="loading" small>
                    <v-icon color="white">mdi-chevron-left</v-icon>
                  </v-btn>
                </div>
                <div>
                  <v-btn icon @click="next(true)" :disabled="loading" small>
                    <v-icon color="white">mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn icon @click="next()" :disabled="loading" small>
                    <v-icon color="white">mdi-chevron-double-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <span
              v-for="(date, dateIndex) in dates"
              :key="dateIndex"
              :class="dateCellStyle(date)"
              class="dates"
            >
              <div v-if="dayHasEvent(date)">
                <v-badge
                  dot
                  :color="getDayEvent(date).color"
                  :title="getDayEvent(date).text"
                  bordered
                >
                  {{ date.format('D') }}
                </v-badge>
                <br>
                <span class="font-weight-thin text-caption">
                  {{ date.locale($locale()).format('dd') }}
                </span>
              </div>
              <div v-else>
                {{ date.format('D') }}
                <br>
                <span class="font-weight-thin text-caption">
                  {{ date.locale($locale()).format('dd') }}
                </span>
              </div>
            </span>
          </div>
          </div>
          <div class="calendar__row calendar__row--lines grid-template-count">
          <div></div>
          <span v-for="(date, dateIndex) in dates" :key="dateIndex" :class="columnClass(date)"></span>
        </div>
        <v-progress-linear v-if="loading" indeterminate/>
        <div id="scroll-element" ref="scroll_element" v-show="!request.loading">
          <by-units
            v-if="filters.view === 2"
            @dropped="updated"
            @reservationClick="openEditing"
            @reservationReplace="reservationReplace"
            @blockClick="openView"
            @unitSelection="openCreationWizard"
            @unitEditing="openUnitEditing"
            @housekeepingClick="housekeepingClick"
          />
          <by-property-units
            v-if="filters.view === 3"
            @dropped="updated"
            @reservationClick="openEditing"
            @reservationReplace="reservationReplace"
            @blockClick="openView"
            @unitSelection="openCreationWizard"
            @unitEditing="openUnitEditing"
            @housekeepingClick="housekeepingClick"
          />
          <detailed
            v-else
            @rateSelection="openCreation"
            @dropped="updated"
            @reservationClick="openEditing"
            @reservationReplace="reservationReplace"
            @blockClick="openView"
            @unitSelection="openCreationWizard"
            @unitEditing="openUnitEditing"
            @unitCategoryEditing="openUnitCategoryEditing"
            @derivationRuleEditing="openDerivationRuleEditing"
            @housekeepingClick="housekeepingClick"
            @pricePerGuestConfig="openPricePerGuestConfig"
          />
          <v-btn id="scroll-up-button" x-small fab @click="scrollUp()" @dragover="scrollUp()">
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
          <v-btn id="scroll-down-button" x-small fab @click="scrollDown()" @dragover="scrollDown()">
            <v-icon>mdi-arrow-down</v-icon>
          </v-btn>
        </div>
      </div>
      <v-btn
        v-if="isLoadMoreEnabled"
        @click="getMoreData"
        :loading="request.loading"
        block
        elevation="0"
        class="mt-2"
        color="blue-grey white--text"
      >
        ... {{ $lang('calendar.load_more') }}
      </v-btn>
      <component :is="'style'">
        .grid-template-days { grid-template-columns: {{ columns }}; }
      </component>
      <component :is="'style'">
        .grid-template-count { grid-template-columns: 200px repeat({{ filters.days }}, 1fr) !important; }
      </component>
    </v-container>

    <v-dialog v-model="isOpenCreation" max-width="1000px" @keydown.enter="$refs.rateCalendarCreationForm.submit()">
      <creation-form
        v-if="isOpenCreation"
        ref="rateCalendarCreationForm"
        :data="creationData"
        @cancel="closeCreation"
        @error="failed"
        @success="created"
      />
    </v-dialog>
    <v-dialog v-model="isOpenBulkCreation" persistent max-width="90vw">
      <creation-bulk-form
        v-if="isOpenBulkCreation"
        @cancel="closeBulkCreation"
        @error="failedBulk"
        @success="createdBulk"
      />
    </v-dialog>
    <v-dialog v-model="isOpenCopy" max-width="50vw">
      <copy-form
        v-if="isOpenCopy"
        @cancel="closeCopy"
        @error="failedCopy"
        @success="successCopy"
      />
    </v-dialog>

    <view-drawer
      v-if="isOpenView"
      :item-id="activeId"
      @close="closeView"
      @updated="updated"
      @openEditing="openEditing"
      @removed="updated"
    />

    <v-dialog v-model="isOpenEditing" persistent fullscreen hide-overlay>
      <editing-form
        v-if="isOpenEditing"
        :item-id="activeId"
        @cancel="closeEditing"
        @error="failedEditing"
        @success="updated"
      />
    </v-dialog>
    <v-dialog v-model="isOpenCreationWizard" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <creation-wizard-form
        v-if="isOpenCreationWizard"
        @cancel="closeCreationWizard"
        @error="failedWizard"
        @success="createdWizard"
        :options="creationWizardOptions"
      />
    </v-dialog>
    <v-dialog v-model="isOpenCreationMultiple" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <creation-multiple-form
        v-if="isOpenCreationMultiple"
        @cancel="closeCreationMultiple"
        @error="failedMultiple"
        @success="createdMultiple"
      />
    </v-dialog>
    <v-dialog v-model="isOpenUnitEditingForm" width="80vw">
      <unit-editing-form
        v-if="isOpenUnitEditingForm"
        :item-id="activeUnitId"
        @cancel="closeUnitEditing"
        @success="closeUnitEditing"
      />
    </v-dialog>
    <v-dialog v-model="isOpenUnitCategoryEditingForm" fullscreen>
      <unit-category-editing-form
        v-if="isOpenUnitCategoryEditingForm"
        :item-id="activeUnitCategoryId"
        @cancel="closeUnitCategoryEditing"
        @success="closeUnitCategoryEditing"
      />
    </v-dialog>
    <v-dialog v-model="isOpenDerivationRuleEditingForm" width="60rem">
      <derivation-editing-form
        v-if="isOpenDerivationRuleEditingForm"
        :item-id="activeDerivationRuleId"
        @cancel="closeDerivationRuleEditing"
        @success="closeDerivationRuleEditing"
      />
    </v-dialog>
    <v-dialog v-model="isOpenPricePerGuestConfig" width="50rem">
      <price-per-guest-config-form
        v-if="isOpenPricePerGuestConfig"
        :payload="activePricePerGuestPayload"
        @cancel="closePricePerGuestConfig"
        @success="closePricePerGuestConfig"
      />
    </v-dialog>
  </div>
</template>

<script>
  import main from "@/pages/calendar/mixins/main";
  import calendar from "@/pages/calendar/mixins/calendar";
  import events from "@/pages/calendar/mixins/events";

  import SettingsMenu from "@/pages/calendar/components/elements/SettingsMenu.vue";
  import Legend from "./components/elements/Legend.vue";

  const Detailed = () => import(/*webpackChunkName: "calendar" */ "@/pages/calendar/components/views/Detailed");
  const ByUnits = () => import(/*webpackChunkName: "calendar" */ "@/pages/calendar/components/views/ByUnits");
  const ByPropertyUnits = () => import(/*webpackChunkName: "calendar" */ "@/pages/calendar/components/views/ByPropertyUnits");

  const UnitEditingForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/units/EditingForm");
  const UnitCategoryEditingForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/unit-categories/EditingForm");
  const DerivationEditingForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/derivations/EditingForm");
  const PricePerGuestConfigForm = () => import(/*webpackChunkName: "calendar" */ "@/pages/unit-categories/PricePerGuestConfigForm");

  import {
    GET_CALENDAR_DATA_RESET,
  } from "@/store/calendar/actions";

  export default {
    name: "CalendarIndex",
    components: {
      Detailed,
      ByUnits,
      ByPropertyUnits,
      UnitEditingForm,
      UnitCategoryEditingForm,
      DerivationEditingForm,
      PricePerGuestConfigForm,
      SettingsMenu,
      Legend,
    },
    mixins: [
      main,
      calendar,
      events,
    ],
    data() {
      return {
        withoutPagination: true,
        distanceFromTop: null,
        monthsDistanceFromTop: null,
        elDistanceFromTop: null,
        period: null,
        isMobile: false,
        wrapperHeight: null,
      }
    },
    async beforeMount() {
      this.isMobile = this.$isMobile();
      await this.initSettings();
      await this.setPreset();
      await this.getData();
      await this.getEvents();
    },
    mounted() {
      let el = this.$refs.dates_row;
      this.elDistanceFromTop = el.getBoundingClientRect().top;
      // this.setFixedHeader();
    },
    async beforeDestroy() {
      await this.$store.dispatch(GET_CALENDAR_DATA_RESET);
    },
    methods: {
      getMoreData() {
        this.getData({
          page: this.pagination.page + 1
        });
      },
      /**
       * NOT used. Managed via sticky header
       */
      setFixedHeader() {
        window.addEventListener("scroll", this.$debounce(() => {
          if (window.scrollY > this.elDistanceFromTop) {
            this.distanceFromTop = window.scrollY - this.elDistanceFromTop - 7;
            this.monthsDistanceFromTop = window.scrollY - this.elDistanceFromTop - 7;
          } else {
            this.distanceFromTop = 0;
            this.monthsDistanceFromTop = 0;
          }
        }, 50));
      },
      columnClass(date) {
        if (date.isSame(this.$moment(), 'day')) return 'is-today';

        const weekDay = date.day();

        if (weekDay === 6 || weekDay === 0) return 'is-weekend';

        return '';
      },
      scrollDown() {
        let el = this.$refs.scroll_element;

        el.scrollBy({
          top: 400,
          behavior: 'smooth'
        });
      },
      scrollUp() {
        let el = this.$refs.scroll_element;

        el.scrollBy({
          top: -400,
          behavior: 'smooth'
        });
      }
    },
    computed: {
      pagination() {
        return this.request.data.pagination || {};
      },
      collection() {
        return this.request.data.collection || [];
      },
      isLoadMoreEnabled() {
        return this.pagination.page < this.pagination.totalPages;
      },
    },
    watch: {
      propertyIds: {
        handler() {
          this.getData();
          this.getEvents();
        },
        deep: true
      },
      period(val) {
        this.filters.date = val;
        this.changeSettings('date');
        this.getEvents();
      },
      'filters.date'(val) {
        this.getEvents();
      }
    },
  };
</script>

<style scoped>
  @import "./styles/calendar.scss";
  #wrapper {
    height: 80vh;
    display: grid;
    align-content: baseline;
  }
  #scroll-element {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    overflow: auto;
  }
  #scroll-element::-webkit-scrollbar {
    display: none;
  }
  #header {
    max-height: 67px;
  }
  #scroll-down-button {
    position: absolute;
    bottom: 30px;
    right: 0px;
    background-color: "rgba(255,255,255, 0.5)";
    z-index: 5;
    overflow: visible;
  }
  #scroll-up-button {
    position: absolute;
    top: 90px;
    right: 0px;
    z-index: 5;
    overflow: visible;
  }
  #ruler {
    position: absolute;
    left: 200px;
    top: 0;
    z-index: 9;
    right: 0;
    height: 20px;
  }
  #track-container {
    width: min-content;
    position: relative;
    max-width: 100%;
  }
  #track {
    width: 5px;
    height: 20px;
    overflow: hidden;
    opacity: 1;
    resize: horizontal;
    position: relative;
    max-width: 100%;
  }
  #track::after {
    content: "";
    width: 15px;
    display: block;
    position: absolute;
    right: -5px;
    bottom: 0;
    height: 20px;
    background: #bb1717;
    border-radius: 100px;
  }
  #track-element {
    background: #bb1717;
    height: calc(80vh - 20px);
    width: 1px;
    float: right;
    pointer-events: none;
  }
</style>
